import { render } from "./ClaimModal.vue?vue&type=template&id=65464329&scoped=true"
import script from "./ClaimModal.vue?vue&type=script&lang=js"
export * from "./ClaimModal.vue?vue&type=script&lang=js"

import "./ClaimModal.vue?vue&type=style&index=0&id=65464329&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65464329"]])

export default __exports__